<template>
  <div class="propertysystem">
    <div class="header">
      <div class="title">智能化物业管理体系</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import propertysystem1 from "../../../../assets/programme/propertysystem1.png";
import propertysystem2 from "../../../../assets/programme/propertysystem2.png";
import propertysystem3 from "../../../../assets/programme/propertysystem3.png";
import propertysystem4 from "../../../../assets/programme/propertysystem4.png";
import propertysystem5 from "../../../../assets/programme/propertysystem5.png";
import propertysystem6 from "../../../../assets/programme/propertysystem6.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          title: "统一管理",
          text: "建立集团统一的主数据管理平台，实现规范、统一的以集团为核心的基础资料管理体系",
          logo: propertysystem1,
        },
        {
          id: 2,
          title: "智慧收费",
          text: "业主在线、缴费在线、管控在线，让收费更轻松，建立更智能的收费场景。通过与财务系统、税控系统的对接，实现业务、财务、税务一体化解决方案",
          logo: propertysystem2,
        },
        {
          id: 3,
          title: "智能安防",
          text: "借助人工智能物联网，让设备会说话、实现自动预警，将安全隐患消灭在萌芽阶段",
          logo: propertysystem3,
        },
        {
          id: 4,
          title: "设备管理",
          text: "全面覆盖物业项目日常品质巡检场景、项目地理区域，实现全方位、无死角品质巡检管理，让客户更满意、更放心、更安心",
          logo: propertysystem4,
        },
        {
          id: 5,
          title: "智能门禁",
          text: "新型现代化安全管理系统，它集微机自动识别技术和现代安全管理措施为一体，涉及电子、机械、光学、计算机技术、通讯技术、生物技术等诸多新技术",
          logo: propertysystem5,
        },
        {
          id: 6,
          title: "在线报修",
          text: "建立服务工单标准业务流程（报事报修、投诉建议），提升业务管控力",
          logo: propertysystem6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertysystem {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item {
  width: 570px;
  text-align: center;
  border: 1px solid #d5e3fa;
  margin-bottom: 40px;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 570px;
}
.body .list .item .title {
  margin-top: 40px;
  color: #248efb;
  font-size: 20px;
}
.body .list .item .text {
  width: 480px;
  margin: 20px auto 27px;
  font-size: 14px;
  color: #495a6c;
}
</style>
